import React, { FC } from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import { Tag } from '@workwave-tidal/core/components/Tag'
import { IKnockStatus } from '@user/store/knockStatus/typings'
import Button from '@mui/material/Button'
import { KnockStatusIcon } from '@user/components/KnockStatus'

interface KnockStatusCardProps {
  status: IKnockStatus
  onEdit?: (id: string) => void
  onDelete?: (id: string) => void
}

export const KnockStatusCard: FC<KnockStatusCardProps> = ({
  status,
  onEdit,
  onDelete,
}) => {
  return (
    <Paper
      variant="outlined"
      sx={{
        px: 1,
        py: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '60px',
      }}
    >
      <Stack direction="row" alignItems="center">
        <Box
          sx={{
            width: 44,
            height: 44,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <KnockStatusIcon
            color={status.color}
            icon={status.icon}
            width={44}
            height={44}
            viewBox={'0 0 50 50'}
          />
        </Box>
        <Typography variant="subtitle1" noWrap sx={{ maxWidth: '200px' }}>
          {status.name}
        </Typography>
      </Stack>

      {status.isSystem ? (
        <Tag
          label="System Status"
          variant="outlined"
          sx={{ borderColor: '#D4E3F3' }}
        />
      ) : (
        <Stack direction="row" spacing={1}>
          <Button
            variant="text"
            onClick={() => onDelete?.(status.id)}
            data-test-id={`deleteStatusBtn-${status.id}`}
          >
            Delete
          </Button>
          <Button
            type="submit"
            variant="outlined"
            onClick={() => onEdit?.(status.id)}
            data-test-id={`editStatusBtn-${status.id}`}
          >
            Edit
          </Button>
        </Stack>
      )}
    </Paper>
  )
}
